import React, { useState } from "react";
import ExitActivityButton from "../UI/Button/ExitActivityButton";

import { handleEventInfoData } from "../../utils/storeConverter";
import { fireActionTriggerCustomEvent } from "../../utils/adobe-launch";

import "./MyGame.css";

function MyGame({ storeId, game }) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [gameNum, setGameNum] = useState(0);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isGame, setIsGame] = useState(false);

  const handleGameNum = (num) => {
    setGameNum((prev) => num);
  };

  const handleGameBoolean = () => {
    setIsGame((prev) => !isGame);
  };

  const PickGameModal = ({ gameArray, changeGameBool }) => (
    <div className="gamePosterContainer">
      {gameArray.map((game, index) => (
        <img
          className={`game ${game.gameTitle}`}
          onClick={(e) => {
            setGameNum(index);
            changeGameBool();

            handleEventInfoData({
              storeName: window.digitalData.pageInfo.page_name,
              page_name:
                window.digitalData.pageInfo.page_name +
                `:play ${game.gameTitle}`,
              location_name: `Game Section`,
            });
            console.log("[next click event] ", window.digitalData);
            fireActionTriggerCustomEvent(e.target, window.digitalData.event);
          }}
          src={game.gamePoster}
          key={`game ${game.gameTitle}`}
          alt={`${game.gameTitle} Game`}
        />
      ))}
      {gameArray.length > 1 ? (
        <p id="gamesOnDesktop">Games play best on desktop</p>
      ) : null}
    </div>
  );

  const GameFrame = ({ gameArray }) => (
    <iframe
      title={gameArray[gameNum].gameTitle}
      scrolling="no"
      style={{ border: "none" }}
      height="581"
      width="1025"
      className={
        gameArray[gameNum].gameTitle === "Courtney Dress Up"
          ? `gameFrame dressUp`
          : "gameFrame poptropica"
      }
      src={gameArray[gameNum].gameUrl}
    ></iframe>
  );

  return (
    <section
      className="gameContainer"
      style={isGame ? { position: "static" } : { position: "relative" }}
    >
      <ExitActivityButton
        gameTitle={game[gameNum].gameTitle}
        className="gameExit"
        storeId={storeId}
      />

      {isGame ? (
        <GameFrame changeGameNum={handleGameNum} gameArray={game} />
      ) : (
        <PickGameModal changeGameBool={handleGameBoolean} gameArray={game} />
      )}
    </section>
  );
}

export default MyGame;
